import React from 'react';
import { useTranslation } from 'react-i18next';
import YesNoAnswersData from '../../../data/Answers/YesNoAnswersData';
import YesNoAnswer from '../../Answer/YesNoAnswer';

import styles from './styles.module.scss';

const YesNoQuestion = ({ number, total, stage, step, question, activeQuestion, setSelectedAnswer, disabled }) => {
  const { t } = useTranslation();
  const answers = YesNoAnswersData();

  return <div className={styles.question + ' ' + (question.answer ? styles.complete : disabled ? styles.disabled : '') + ' ' + (number === activeQuestion ? styles.active : '')}>
    <h3 className={styles.title}>
      {t(`tool_ui.${stage.key}.${question.key}`)}
    </h3>
    <div className={styles.answers}>
      {answers.map((answer, index) => <YesNoAnswer
        key={index}
        question={question}
        item={answer}
        setSelectedAnswer={setSelectedAnswer}
        disabled={disabled}
      />)}
    </div>
  </div>;
}

export default YesNoQuestion;
